import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TFunction } from 'i18next';
import { IconName } from '@fortawesome/pro-light-svg-icons';

import Flex from '../../../components/Flex';
import classNames from 'classnames';
import { makePrioStyles } from '../../../theme/utils';
import { PrioTheme } from '../../../theme/types';
import { useTheme } from 'react-jss';
import { Classes } from 'jss';

const useStyles = makePrioStyles((theme) => ({
  root: {},
  title: {
    lineHeight: '44px!important',
    padding: `${theme.old.spacing.unit(2)}px ${
      theme.old.spacing.defaultPadding
    }px`,
    margin: '0!important',
  },
  menu: {
    background: 'none',
    border: 'none',
    padding: `0 ${theme.old.spacing.defaultPadding}px`,
  },
  icon: {
    marginRight: theme.old.spacing.unit(1.5),
    width: 18,
  },
}));

const navItem = (
  itemKey: string,
  icon: IconName,
  t: TFunction,
  classes: Classes,
  urlPrefix?: string,
  customUrl?: string
) => (
  <Menu.Item key={itemKey}>
    <Link to={customUrl ?? `${urlPrefix ?? ''}${itemKey}`}>
      <FontAwesomeIcon
        fixedWidth
        icon={['fal', icon]}
        className={classes.icon}
      />
      {t(`hr:hrTrainingsMenu.navigation.${itemKey}`)}
    </Link>
  </Menu.Item>
);

interface HRTrainingsMenuProps {
  selectedList?: string;
  className?: string;
  urlPrefix?: string;
}

export const HRTrainingsMenu: React.FC<HRTrainingsMenuProps> = (props) => {
  const { selectedList, urlPrefix, className } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();

  return (
    <Flex.Column
      flexGrow={1}
      className={classNames('prio-module-navigation', classes.root, className)}
    >
      <Typography.Title className={classes.title}>
        {t('hr:hrTrainingsMenu.title')}
      </Typography.Title>
      <Menu
        className={classes.menu}
        selectedKeys={[selectedList]}
        mode="inline"
        inlineIndent={theme.old.components.menuInlineIndent}
      >
        {navItem('trainings', 'calendar-alt', t, classes, urlPrefix)}
        {navItem('archive', 'archive', t, classes, urlPrefix)}
      </Menu>
    </Flex.Column>
  );
};
